module.exports = __webpack_public_path__ + "static/media/6.53157fe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/beards/6.png
// module id = 1190
// module chunks = 0